import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['trigger', 'toShow'];

  static values = { animationType: String };

  expand() {
    $(this.triggerTarget).hide(0, () => {
      if (this.animationTypeValue === 'instant') {
        $(this.toShowTarget).show();
      } else {
        $(this.toShowTarget).slideDown();
      }
    });
  }
}
